import {createContext, useContext} from 'react';

const SpaPropsContext = createContext({});

// eslint-disable-next-line react/prop-types
const SpaPropsProvider = ({children, spaProps}) => <SpaPropsContext.Provider value={{spaProps}}>{children}</SpaPropsContext.Provider>;

export const useSpaPropsContext = () => useContext(SpaPropsContext);

export default SpaPropsProvider;
